import { CardNaoEncontrado } from "views/components/cards";
import { InformacaoIcon } from "views/components/icons";
import { Grid, Typography } from '@material-ui/core'
import { useStyles } from "./historico-transferencia-styles";
import { TransferenciaHistoricoModel } from "model/api/gestao/transferencia/transferencia-historico-model";
import { CardHistoricoTransferencia } from "views/components/cards/card-historico-transferencia/card-historico-transferencia";

interface HistoricoListDataProps {
    list: TransferenciaHistoricoModel[];
    onCardClick: (model: TransferenciaHistoricoModel) => void;
}

export const HistoricoTransferenciaData = ({
    list,
    onCardClick
}: HistoricoListDataProps) => {
    const classes = useStyles();

    const sortedList = [...list].sort((a, b) => {
        return new Date(b.dataOcorrencia).getTime() - new Date(a.dataOcorrencia).getTime();
    });

    const hasOcorrencia = list.some(item => !!item.ocorrencia);

    const hasOcorrenciaRetorno = list.some(item => !!item.ocorrenciaRetorno);

    const hasMotivoRejeicao = list.some(item => Boolean(item.codigoMotivoRejeicao && item.codigoMotivoRejeicao > 0));

    const neitherExtra = !hasOcorrenciaRetorno && !hasMotivoRejeicao;

    const mdBase = neitherExtra ? 3 : 2;

    const mdOcorrencia = hasOcorrenciaRetorno && hasMotivoRejeicao ? 2 : 3;

    return (
        <>
            {list.length > 0 && <Grid container spacing={2} className={classes.listLabels}>
                <Grid item xs={6} md={mdBase}>
                    <Typography variant='caption' color='textSecondary'>
                        Data
                    </Typography>
                </Grid>
                <Grid item xs={6} md={mdBase}>
                    <Typography variant='caption' color='textSecondary'>
                        Status
                    </Typography>
                </Grid>
                <Grid item xs={6} md={mdBase}>
                    <Typography variant='caption' color='textSecondary'>
                        Evento
                    </Typography>
                </Grid>
                {hasOcorrencia && (
                    <Grid item xs={6} md={mdOcorrencia}>
                        <Typography variant='caption' color='textSecondary'>
                            Ocorrência
                        </Typography>
                    </Grid>
                )}
                {hasOcorrenciaRetorno && (
                    <Grid item xs={6} md={2}>
                        <Typography variant='caption' color='textSecondary'>
                            Ocorrência Retorno
                        </Typography>
                    </Grid>
                )}
                {hasMotivoRejeicao && (
                    <Grid item xs={6} md={2}>
                        <Typography variant='caption' color='textSecondary'>
                            Motivo Rejeição
                        </Typography>
                    </Grid>
                )}
            </Grid>}
            {(list.length === 0) && (
                <CardNaoEncontrado
                    icon={<InformacaoIcon tipo='GERAL' />}
                    mensagem="Nenhum Histórico foi encontrado."
                />
            )}
            {sortedList.map((item) => {
                return (
                    <CardHistoricoTransferencia
                        model={item}
                        existeAlgumaOcorrenciaRetorno={hasOcorrenciaRetorno}
                        existeAlgumaRejeicao={hasMotivoRejeicao}
                    />
                )
            })}

        </>
    )
}

